import angular from 'angular';
import statuesTemplate from './templates/statuses.template.html';

/*******************************************************************************
 * Component: statusesEntityContent
 *
 * Component to manage the Statuses route content.
 *******************************************************************************/
export const statusesEntityContentComponent = {
  require: { dialogCtrl: '^^entitiesAdmin' },
  template: statuesTemplate,
  controller: 'StatusesEntityController',
  controllerAs: '$statusesCtrl'
};

/* @ngInject */ export function StatusesEntityController(
  $location,
  $q,
  $sce,
  $scope,
  $timeout,
  $window,
  AddChangeTagDialog,
  Alert,
  SERVER,
  BooksSvc,
  BusyScreen,
  CommonUIGridTemplates,
  EntityAdminListItem,
  EntitiesAdminService,
  uiGridConstants,
  Session
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance. */ var mThis = this;
  /** AddChangeTagDialog shown. */ var mTagDialogActive = false;

  mThis.data = {};

  /*----------------------*/
  /* Item report options. */
  /*----------------------*/
  var REPORT_PDF = { label: 'PDF' };
  var REPORT_HTML = { label: 'HTML' };
  var REPORT_EXCEL = { label: 'Excel' };

  /** Upload page URI. */
  var UPLOAD_URI = 'apps/StatusUpload.aspx?tid=';

  /** Report Types List.  */ mThis.dpReportTypes = [
    REPORT_PDF,
    REPORT_HTML,
    REPORT_EXCEL
  ];
  /** Default Report Type */ mThis.activeReportType = mThis.dpReportTypes[0];

  /*-------------------------------------------------*/
  /* Editable cell template for the name field in    */
  /* the Students Grid. On edit, displays a          */
  /* typeahead to search for students by their name. */
  /*-------------------------------------------------*/
  var studentCellTemplate =
    '<div style="display:block; height: 100%; z-index:1;"> ' +
    '<form name="inputForm" style="display:block; height:100%;">' +
    '<input type="INPUT_TYPE" ng-class="\'colt\' + col.uid" ui-grid-edit-typeahead ng-model="row.entity" ' +
    ' uib-typeahead="name as name.labelFunction for name in grid.appScope.availableNames | filter:{ labelFunction: $viewValue } | limitTo:8" ' +
    ' typeahead-on-select="grid.appScope.handleStudentAdd(row, $item, $model)" typeahead-select-on-blur="true" typeahead-append-to-body="true" style="display:block; height:100%;" />' +
    '</form>' +
    '</div>';

  /*------------------------*/
  /* Students grid options. */
  /*------------------------*/
  mThis.dgStudents = {
    enableColumnMenus: false,
    showHeader: false,
    enableCellEdit: false,
    enableCellEditOnFocus: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
    minRowsToShow: 8,
    onRegisterApi: function (gridApi) {
      mThis.dgStudents.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        name: 'labelFunction',
        cellEditableCondition: allowStudentCellChange,
        editableCellTemplate: studentCellTemplate,
        enableCellEdit: true
      },
      {
        field: 'delete',
        maxWidth: 10,
        cellTemplate: CommonUIGridTemplates.CELL_DELETE_ROW,
        displayName: ' ',
        enableSorting: false,
        appScope: $scope
      }
    ]
  };

  /***************************************************************************
   * allowStudentCellChange */
  /**
   * Returns an indication a grid cell can edited. Once a student has been
   * selected, editing is locked.
   *
   * @param   Object    ui-grid grid scope
   * @return  boolean   Indication to edit items
   ***************************************************************************/
  function allowStudentCellChange(gridScope) {
    return !(gridScope.row.entity && gridScope.row.entity.id);
  }

  /***************************************************************************
   * deleteStudent */
  /**
   * Remove the entity from the current status tag.
   *
   * @param   grid    Reference to the ui-grid
   * @param   row     Row reference to be deleted.
   ***************************************************************************/
  var deleteStudent = function (grid, row) {
    var entityToDelete = row.entity;

    /*--------------------------*/
    /* Nothing to delete, exit. */
    /*--------------------------*/
    if (!entityToDelete || !entityToDelete.id) return;

    Alert.confirm(
      'Do you want to remove this student from ' +
        mThis.data.activeTag.description +
        '?'
    ).then(function () {
      /*-------------------------------------------------------*/
      /* Remove student from status tag, update tagged         */
      /* students list and refresh list of available students. */
      /*-------------------------------------------------------*/
      BusyScreen.setBusy(true);
      BooksSvc.removeStatus(entityToDelete.id, mThis.data.activeTag.id).then(
        function (resp) {
          mThis.tagSelected();
          BusyScreen.setBusy(false);
          Alert.success(
            (entityToDelete.name || entityToDelete.fullName) +
              ' removed from ' +
              mThis.data.activeTag.description,
            'Removed'
          );
        }
      );
    });
  };

  /*****************************************************************************
   * generateReport */
  /**
   * Handles the click to generate a report of the active selected type.
   *****************************************************************************/
  mThis.generateReport = function () {
    /*----------------------*/
    /* XML request payload. */
    /*----------------------*/
    var xmlString =
      '<StatusReportRequest>' +
      '<tagID>' +
      mThis.data.activeTag.id +
      '</tagID>' +
      '<reportFormat>' +
      mThis.activeReportType.label +
      '</reportFormat>' +
      '</StatusReportRequest>';

    /*--------------*/
    /* Create form. */
    /*--------------*/
    var form = document.createElement('form');
    form.setAttribute('action', Session.getSessionURL('/StatusReport.aspx'));
    form.setAttribute('method', 'POST');
    form.setAttribute('target', '_blank');
    form.setAttribute('ENCTYPE', 'text/plain');
    form.setAttribute('style', 'display: none');

    /*---------------------------------------*/
    /* Add a hidden input field to the form. */
    /*---------------------------------------*/
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', '<?xml version');
    hiddenField.setAttribute('value', '"1.0"?>' + xmlString);
    form.appendChild(hiddenField);

    /*-----------------------------------------------*/
    /* Add form to page and submit then remove form. */
    /*-----------------------------------------------*/
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  /***************************************************************************
   * handleClear */
  /**
   * Removes all students from the active tag.
   ***************************************************************************/
  mThis.handleClear = function () {
    /*----------------------------------*/
    /* No tag selected to modify, exit. */
    /*----------------------------------*/
    if (!mThis.isTagSelected()) {
      Alert.error('No tag selected.');
      return;
    }

    /*-----------------*/
    /* Confirm remove. */
    /*-----------------*/
    Alert.confirm(
      'This will remove all students from this status, and cannot be undone. Are you sure?',
      'Clear Status'
    ).then(function () {
      /*-------------------------------------*/
      /* Clear students and refesh the list. */
      /*-------------------------------------*/
      BusyScreen.setBusy(true);
      BooksSvc.clearStatus(mThis.data.activeTag.id).then(function (resp) {
        mThis.tagSelected();
        BusyScreen.setBusy(false);
        Alert.success('All students removed.');
      });
    });
  };

  /*****************************************************************************
   * handleStudentAdd */
  /**
   * Handles the addition of students to the grid. Fires when the lazyTypeahead
   * input blurs.
   *
   * @param  item
   * @param  model
   * @param  label
   *****************************************************************************/
  mThis.handleStudentAdd = function (row, item, model) {
    /*---------------------------------------------------------*/
    /* Nothing selected from typeahead or no active tag, exit. */
    /*---------------------------------------------------------*/
    if (!row.entity.id || !mThis.data.activeTag.id) return;

    /*-----------------------------------------------*/
    /* Call service to assign status tag to student. */
    /*-----------------------------------------------*/
    BusyScreen.setBusy(true);
    BooksSvc.assignStatus(row.entity.id, mThis.data.activeTag.id).then(
      function (resp) {
        mThis.tagSelected();
        BusyScreen.setBusy(false);

        /*-----------------------------------------------------*/
        /* Scroll to the bottom of the grid and place focus on */
        /* the cell to allow user to continue adding students. */
        /*-----------------------------------------------------*/
        $timeout(function () {
          var row =
            mThis.dgStudents.data[
              mThis.dgStudents.api.core.getVisibleRows().length - 1
            ];
          var col = mThis.dgStudents.columnDefs[0];
          mThis.dgStudents.api.cellNav.scrollToFocus(row, col);
        }, 200);

        Alert.success(
          (row.entity.name || row.entity.fullName) +
            ' added to ' +
            mThis.data.activeTag.description,
          'Added'
        );
      }
    );
  };

  /*****************************************************************************
   * handleTag */
  /**
   * Handles the requests to adds a Tag.
   *****************************************************************************/
  mThis.handleTag = function () {
    /*-------------------------------*/
    /* Dialog already active, abort. */
    /*-------------------------------*/
    if (mTagDialogActive) return;

    /*------------------------------------------*/
    /* Display the dialog to add a new tag with */
    /* status tag as the only tag type allowed. */
    /*------------------------------------------*/
    mTagDialogActive = true;
    AddChangeTagDialog.show(null, [SERVER.BooksDBConstants.TT_STATUS])
      .then(function (tag) {
        /*----------------------------------------------------------*/
        /* Reload the list of tags and select the newly added item. */
        /*----------------------------------------------------------*/
        EntitiesAdminService.reloadStatuses().then(function () {
          /**
           * We sort the tags by description here instead of in SQL, because the SQL
           * query uses ORDER BY on the Indicator field and then the Description field.
           * Therefore, if we changed the SQL query to sort by Description first,
           * it would cause a change in the order of the tags displayed in the UI for
           * other pages that use the same query to populate their tag lists and use the
           * indicator field instead.
           */
          mThis.data.tags = EntitiesAdminService.getStatuses().sort((a, b) =>
            (a.description || '').localeCompare(b.description || '')
          );
          mThis.data.activeTag = mThis.data.tags
            .filter(function (t) {
              return t.id == tag.id;
            })
            .shift();
          mThis.tagSelected();
        });
      })
      ['finally'](function () {
        mTagDialogActive = false;
      });
  };

  /*****************************************************************************
   * isTagSelected */
  /**
   * Returns an indication that a tag has been selected.
   *
   * @return  Boolean  True=tag selected.
   *****************************************************************************/
  mThis.isTagSelected = function () {
    return mThis.data.activeTag != null;
  };

  /*****************************************************************************
   * $onInit */
  /**
   * Initialization callback function. The required dialogCtrl will be available
   * at this point for initialization purposes.
   *****************************************************************************/
  mThis.$onInit = function () {
    /*-----------------------------------------------------*/
    /* To have a reference to the app scope in the grid    */
    /* row template, the grid appScopeProvider will need   */
    /* to be manually setup since we are not using $scope. */
    /*-----------------------------------------------------*/
    mThis.dgStudents.appScopeProvider = this;

    /*-----------------------------------------------------------*/
    /* Populate the statuses list and select the first available */
    /* tag in the selection list and get it's tagged entities.   */
    /*-----------------------------------------------------------*/
    BusyScreen.setBusy(true);
    EntitiesAdminService.reloadStatuses().then(function () {
      BusyScreen.setBusy(false);
      /**
       * We sort the tags by description here instead of in SQL, because the SQL
       * query uses ORDER BY on the Indicator field and then the Description field.
       * Therefore, if we changed the SQL query to sort by Description first,
       * it would cause a change in the order of the tags displayed in the UI for
       * other pages that use the same query to populate their tag lists and use the
       * indicator field instead.
       */
      mThis.data.tags = EntitiesAdminService.getStatuses().sort((a, b) =>
        (a.description || '').localeCompare(b.description || '')
      );
      mThis.data.activeTag =
        mThis.data.tags.length > 0 ? mThis.data.tags[0] : null;
      mThis.tagSelected();
    });

    /*--------------------------------------------------*/
    /* Reload the tagged students when the upload page  */
    /* in the iframe reports that an import has ended.  */
    /*--------------------------------------------------*/
    $window.addEventListener('message', onUploadMessage);
    $scope.$on('$destroy', function () {
      $window.removeEventListener('message', onUploadMessage);
    });
  };

  /*****************************************************************************
   * loadTaggedEntities */
  /**
   * Populates the students grid with the entities tagged with the active tag.
   *
   * @return  Promise resolved once the grid is populated.
   *****************************************************************************/
  function loadTaggedEntities() {
    return BooksSvc.getTaggedEntities(mThis.data.activeTag.id).then(
      function (resp) {
        /*--------------------------------------------------------------*/
        /* Populate the grid with the entities as EntityAdminListItems. */
        /*--------------------------------------------------------------*/
        mThis.dgStudents.data = resp.data.map(function (e) {
          return new EntityAdminListItem(e);
        });

        /*------------------------------------------------*/
        /* Refresh the list of available students to add. */
        /*------------------------------------------------*/
        refreshStudentsList();

        /*---------------------------------------------------------------*/
        /* Add a dummy row to the grid to allow for adding new students. */
        /*---------------------------------------------------------------*/
        mThis.dgStudents.data.push(new EntityAdminListItem());
      }
    );
  }

  /*****************************************************************************
   * onUploadMessage */
  /**
   * Window message handler. Reloads the tagged students when the upload page
   * in the iframe posts "statusImportEnd".
   *
   * @param  event  Window message event.
   *****************************************************************************/
  function onUploadMessage(event) {
    var iframe = document.getElementById('iframeUpload');

    if (
      event.data !== 'statusImportEnd' ||
      event.origin !== $window.location.origin ||
      !iframe ||
      event.source !== iframe.contentWindow ||
      !mThis.isTagSelected()
    )
      return;

    $scope.$applyAsync(loadTaggedEntities);
  }

  /*****************************************************************************
   * onReportType */
  /**
   * Report selection handler. Updates the active report type with the user's
   * selection so it is visible on the button and generates a report of the active
   * type.
   *
   * @param  reportType  Selected report type
   *****************************************************************************/
  mThis.onReportType = function (reportType) {
    mThis.activeReportType = reportType;
    mThis.generateReport();
  };

  /*****************************************************************************
   * refreshStudentsList */
  /**
   * Populates the list of available names, excluding those that are tagged with
   * the current active tag for the lazyTypeahead.
   *****************************************************************************/
  function refreshStudentsList() {
    mThis.availableNames = EntitiesAdminService.getNames().filter(
      function (name) {
        return (
          mThis.dgStudents.data
            .filter(function (stu) {
              return stu.id == name.id;
            })
            .shift() == null
        );
      }
    );
  }

  /*****************************************************************************
   * tagSelected */
  /**
   * Fired when a tag is selected. Populates the table with the list of tagged
   * entities.
   *****************************************************************************/
  mThis.tagSelected = function () {
    /*------------------------*/
    /* No tag selected, exit. */
    /*------------------------*/
    if (!mThis.isTagSelected()) return;

    /*-------------------------------------------------*/
    /* Set a promise to resolve once the iframe loads. */
    /*-------------------------------------------------*/
    var iframe = angular.element(document.getElementById('iframeUpload'));
    var iframeDefer = $q.defer();
    iframe.one('load', iframeDefer.resolve);

    /*-------------------------------------------------*/
    /* Update the student upload iframe with the       */
    /* correct url for the selected status tag, making */
    /* sure to preserve the session ID in the url.     */
    /*-------------------------------------------------*/
    var urlEnd = $location.absUrl().indexOf('))/') + 3;
    var baseUrl = $location.absUrl().substring(0, urlEnd);
    iframe.attr(
      'src',
      $sce.trustAsResourceUrl(baseUrl + UPLOAD_URI + mThis.data.activeTag.id)
    );

    /*------------------------------------------*/
    /* Get the tagged entities and load iframe. */
    /*------------------------------------------*/
    BusyScreen.setBusy(true);
    $q.all([iframeDefer.promise, loadTaggedEntities()]).then(function () {
      BusyScreen.setBusy(false);
    });
  };

  /*----------------------------------------*/
  /* Set up listener for the student delete */
  /* event and process for the provided row */
  /*----------------------------------------*/
  $scope.$on(
    CommonUIGridTemplates.EVENT_DELETE_ROW,
    function (event, grid, row) {
      deleteStudent(grid, row);
    }
  );
}
